import React, { useEffect, useRef, useState } from "react";
import { TreeSelect } from "primereact/treeselect";
import CustomeButton from "../Button";
import "./style.scss";

const FilterDropdown = ({
  groupedOptions = [],
  value = {},
  onChange = () => {},
  applyFilter = () => {},
  deSelectAll = () => {},
  placeholder = "Select Filters",
  filterCount,
  loading = false,
}) => {
  const treeSelectRef = useRef();
  const [distance, setDistance] = useState(0);
  const divRef = useRef(null);

  useEffect(() => {
    const element = divRef.current;
    if (element) {
      const rect = element.getBoundingClientRect();
      const distanceFromRight = window.innerWidth - rect.right;
      setDistance(distanceFromRight);
    }
  }, []);

  const treeData = groupedOptions.map((group) => {
    const groupId = group.id;
    let children = [];

    if (Array.isArray(group.suboptions)) {
      children = group.suboptions
        .filter((item) => item?.code)
        .map((item) => ({
          key: item.code,
          label: item.name || item.code,
          icon: item.icon,
          groupKey: groupId,
        }));
    }

    const selectedCount = children.filter(
      (item) => value[item.key]?.checked,
    ).length;

    return {
      key: groupId,
      label: `${group.name}${selectedCount ? ` (${selectedCount})` : ""}`,
      selectable: false,
      children,
    };
  });

  const extractGroupedValues = (treeValue, treeData) => {
    const grouped = {};
    const traverse = (nodes) => {
      nodes.forEach((node) => {
        if (node.children) {
          traverse(node.children);
        } else {
          const isChecked = treeValue[node.key]?.checked;
          if (isChecked && node.groupKey) {
            if (!grouped[node.groupKey]) grouped[node.groupKey] = [];
            grouped[node.groupKey].push(node.key);
          }
        }
      });
    };
    traverse(treeData);
    return grouped;
  };

  return (
    <div
      className={`custom__multiselect ${distance < 180 ? "position__left" : ""}`}
      ref={divRef}
    >
      <CustomeButton
        label={`Filter (${filterCount})`}
        icon="pi pi-filter"
        iconPos="right"
        loading={loading}
        onClick={() => treeSelectRef.current?.show()}
      />

      <TreeSelect
        ref={treeSelectRef}
        value={value}
        onChange={(e) => {
          onChange({
            value: e.value,
            grouped: extractGroupedValues(e.value, treeData),
          });
        }}
        options={treeData}
        selectionMode="checkbox"
        display="chip"
        filter
        filterBy="label"
        placeholder={placeholder}
        className="hidden-treeselect"
        valueTemplate={() => null}
        dropdownIcon={null}
        panelFooterTemplate={() => (
          <div className="filter__action">
            <CustomeButton
              label="Deselect All"
              className="access-btn"
              onClick={deSelectAll}
            />
            <CustomeButton
              label="Apply Filters"
              className="access-btn"
              variant="contained"
              onClick={applyFilter}
            />
          </div>
        )}
        panelClassName="custom-tree-panel"
      />
    </div>
  );
};

export default FilterDropdown;
